import React, { Component } from "react";
import axios from "axios";

import Loading from "../../components/Loading";

class ValidateToken extends Component {
  static displayName = "Validate Token Password Page";

  componentDidMount() {
    const token = this.props.match.params.token;
    axios
      .get("/auth/reset-password/callback/" + token)
      .then(res => {
        window.location.href = "/reset-password/new/" + token;
      })
      .catch(function(error) {
        alert("Password reset token is invalid");
        window.location.href = "/login";
      });
  }

  render() {
    return <Loading />;
  }
}

export default ValidateToken;



// WEBPACK FOOTER //
// ./src/system/containers/ForgotPassword/ValidateToken.jsx